import { returnConfigVariable } from "./helpers";

export const baseUrl: string = returnConfigVariable("REACT_APP_BASE_URL");
export const baseBusinessUrl: string = baseUrl;

// export const baseUrl: string = "https://altonlineaccountopening-api-v3.az-sterlingapp-tcoe-dev.p.azurewebsites.net/api/"
//Docker alternative
// export const baseUrl: string = "https://altonlineaccountopening-api-v3.az-sterlingapp-tcoe-dev.p.azurewebsites.net/api/"
// export const baseBusinessUrl: string =
//      "https://altonlineaccountopeningapibackend.sterlingapps.p.azurewebsites.net/api/";
// "https://altonlineaccountopening-api-v3.az-sterlingapp-tcoe-dev.p.azurewebsites.net/api/"
// "https://altonlineaccountopeningbe-new-dev.sterlingapps.p.azurewebsites.net/api/";
// // export const baseUrl: string =
// // "https://altonlineaccountopeningapibackend.sterlingapps.p.azurewebsites.net/api/";

// //   "https://altonlineaccountopeningbe-new-dev.sterlingapps.p.azurewebsites.net/api/"
// //   "https://altonlineaccountopeningapibackend.sterlingapps.p.azurewebsites.net/api/"
// // // export const baseUrl: string = "https://newonlineaccountopeningapi-pilot.az-appsupport2-ase.p.azurewebsites.net/api/";
// // // // export const baseUrl:string = 'https://altonlineaccountopeningapi-qa.sterlingapps.p.azurewebsites.net/api/'
// // // export const baseBusinessUrl: string =
// // "https://altonlineaccountopeningbe-new-dev.sterlingapps.p.azurewebsites.net/api/"
// // // //   "https://altonlineaccountopeningapibackend.sterlingapps.p.azurewebsites.net/api/";
// // // "https://newonlineaccountopeningapi-pilot.az-appsupport2-ase.p.azurewebsites.net/api/";
// // // export const baseUrl: string =
// // // "https://altonlineaccountopeningapibackend.sterlingapps.p.azurewebsites.net/api/";

// // //   "https://altonlineaccountopeningbe-new-dev.sterlingapps.p.azurewebsites.net/api/"
// // //   "https://altonlineaccountopeningapibackend.sterlingapps.p.azurewebsites.net/api/"
// // // // export const baseUrl: string = "https://newonlineaccountopeningapi-pilot.az-appsupport2-ase.p.azurewebsites.net/api/";
// // // // // export const baseUrl:string = 'https://altonlineaccountopeningapi-qa.sterlingapps.p.azurewebsites.net/api/'
// // // // export const baseBusinessUrl: string =
// // // "https://altonlineaccountopeningbe-new-dev.sterlingapps.p.azurewebsites.net/api/"
// // // // //   "https://altonlineaccountopeningapibackend.sterlingapps.p.azurewebsites.net/api/";
// // // // "https://newonlineaccountopeningapi-pilot.az-appsupport2-ase.p.azurewebsites.net/api/";
// // // // export const baseUrl: string =
// // // // //   "https://altonlineaccountopeningapibackend.sterlingapps.p.azurewebsites.net/api/";
// // // //   "https://altonlineaccountopeningbe-new-dev.sterlingapps.p.azurewebsites.net/api/"
// // // // //   "https://altonlineaccountopeningapibackend.sterlingapps.p.azurewebsites.net/api/"
// // // // // export const baseUrl: string = "https://newonlineaccountopeningapi-pilot.az-appsupport2-ase.p.azurewebsites.net/api/";
